const EXTENSION_MIME: Record<string, string> = {
	jpg: "image/jpeg",
	jpeg: "image/jpeg",
	png: "image/png",
	webp: "image/webp",
	gif: "image/gif",
	bmp: "image/bmp",
	heic: "image/heic",
	heif: "image/heif",
	avif: "image/avif",
	svg: "image/svg+xml",
	mp4: "video/mp4",
	webm: "video/webm",
	mov: "video/quicktime",
	m4v: "video/mp4",
	pdf: "application/pdf",
	xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	xls: "application/vnd.ms-excel",
	csv: "text/csv",
};

const TYPE_ALIASES: Record<string, string> = {
	"image/jpg": "image/jpeg",
	"image/pjpeg": "image/jpeg",
	"image/x-png": "image/png",
	"image/heic-sequence": "image/heic",
	"application/csv": "text/csv",
};

function extensionOf(fileName: string): string {
	const base = fileName.trim().split(/[/\\]/).pop() ?? "";
	const dot = base.lastIndexOf(".");
	if (dot < 0 || dot === base.length - 1) return "";
	return base.slice(dot + 1).toLowerCase();
}

/** Basename for `POST /upload/v1/media/signed-url` `fileName`, e.g. `photo.jpg`. */
export function toSignedUrlFileName(file: File): string {
	const base = file.name.trim().split(/[/\\]/).pop() ?? "";
	return base;
}

/**
 * MIME sent to both the signed-url API and the S3 PUT.
 * Windows often sends an empty `file.type`; fall back to the extension.
 * `.csv` is always `text/csv` — Excel may report CSV as `application/vnd.ms-excel`.
 */
export function inferUploadContentType(file: File): string {
	const ext = extensionOf(file.name);
	if (ext === "csv") return "text/csv";
	const raw = file.type.trim().toLowerCase();
	if (raw && raw !== "application/octet-stream") {
		return TYPE_ALIASES[raw] ?? raw;
	}
	return EXTENSION_MIME[ext] ?? "";
}
